// Home page per backend role name — mirrors the mobile app landing on its
// home tab right after login. Anything not listed falls back to the admin
// home page, since this app's only fully-wired workflows are admin/superuser.
const ROLE_LANDING_PAGES = {
  admin: "/admin",
  staff: "/supervisor-dashboard",
  supervisor: "/supervisor-dashboard",
  customer: "/customer-updates",
};
const DEFAULT_HOME_PAGE = "/admin";

export function getRoleHomePage(roleName) {
  return ROLE_LANDING_PAGES[roleName?.toLowerCase()] || DEFAULT_HOME_PAGE;
}
